import { Flex } from 'antd';
import styles from './insights-cards-wrapper.module.scss';
import { Insight, Insights } from '@/services/dashboard-service/dashboard.service.types';
import AverageCSATScore from '../average-csat-score/average-csat-score';
import { getSortedInsight, sumDataValue, sumLanguageDistributionData } from '@/utils/helpers';
import InsightsDataWrapper from '../insights-data-wrapper/insights-data-wrapper';
import { InsightsTitles } from '@/constants/insights.constants';
import { tooltips } from './insights-cards-wrapper.utils';
import { useState } from 'react';
import { Modal } from '@/components/modal/modal';
import { TrendingTopicsDetails } from '@/components/trending-topics-details/trending-topics-details';

interface InsightsCardsWrapperProps {
  insightsData?: Insights;
  insight: Insight;
  isLoading: boolean;
  isExporting?: boolean;
  onExport: () => void;
}

export default function InsightsCardsWrapper({
  insightsData,
  insight,
  isLoading,
  isExporting,
  onExport,
}: InsightsCardsWrapperProps) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const toggleModalOpen = () => {
    setIsModalOpen((prev) => !prev);
  };

  const countData = (dataToSum?: Insight) => (dataToSum ? sumDataValue(dataToSum) : 0);

  const trending_topics = getSortedInsight(insightsData?.trending_topics, 5);
  const trending_topicsTotal = getSortedInsight(insightsData?.trending_topics);
  const sumOfTrendingTopics = countData(trending_topicsTotal);
  const sumOfTop5Topics = countData(trending_topics);

  const sumOfLanguageDistributionData = insightsData?.language_distribution ? sumLanguageDistributionData(insightsData.language_distribution) : 0;

  const bigChartFirstCol = false;

  return (
    <Flex className={styles.insightsCardsWrapper}>
      <Flex className={styles.insightsCardsContainer}>
        <InsightsDataWrapper
          tooltip={tooltips.trendingTopics}
          title={InsightsTitles.TRENDING_TOPICS}
          isLoading={isLoading}
          data={trending_topics}
          sumOfData={sumOfTrendingTopics}
          sumForWidth={sumOfTop5Topics}
          bigChart={bigChartFirstCol}
          className={styles.trendingTopicsContainer}
          contentProps={{ gap: 8, vertical: true }}
          indexValues
          onShowMoreButtonClick={toggleModalOpen}
        />
        {!bigChartFirstCol && (
          <AverageCSATScore
            isLoading={isLoading}
            overallSatisfactionData={insightsData?.overall_satisfaction}
          />
        )}
      </Flex>
      <Flex className={styles.insightsCardsContainer}>
        <InsightsDataWrapper
          title={InsightsTitles.LANGUAGE_DISTRIBUTION}
          tooltip={tooltips.languageDistribution}
          isLoading={isLoading}
          data={insightsData?.language_distribution}
          sumOfData={sumOfLanguageDistributionData}
          bigChart={!bigChartFirstCol}
          sumForWidth={sumOfTop5Topics}
          className={styles.languageDistributionContainer}
          contentProps={{ gap: 8 }}
          vertical
        />

        {bigChartFirstCol && (
          <AverageCSATScore
            isLoading={isLoading}
            overallSatisfactionData={insightsData?.overall_satisfaction}
          />
        )}
      </Flex>

      <Modal
        isExporting={isExporting}
        onCancel={toggleModalOpen}
        onConfirm={onExport}
        isOpen={isModalOpen}
        title={'Trending topics details'}
      >
        <TrendingTopicsDetails topicsData={insight} />
      </Modal>
    </Flex>
  );
}
